
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.641 15.787h-2.39v-3.849c0-.966-.346-1.626-1.212-1.626-.66 0-1.054.445-1.226.875-.064.153-.079.368-.079.583v4.017H9.343s.031-6.52 0-7.194h2.391v1.02c.318-.49.885-1.188 2.155-1.188 1.573 0 2.752 1.028 2.752 3.237v4.125zM6.825 7.612h-.017c-.802 0-1.32-.553-1.32-1.244 0-.705.534-1.243 1.352-1.243.818 0 1.322.538 1.337 1.243 0 .69-.519 1.244-1.352 1.244zm-1.196 8.175h2.39V8.593H5.63v7.194zM19.841 0H1.159C.52 0 0 .519 0 1.16v18.68C0 20.48.519 21 1.16 21h18.68c.64 0 1.16-.52 1.16-1.16V1.16C21 .518 20.48 0 19.84 0z","fill":"#BF9C5F","fill-rule":"evenodd"}})])
          )
        }
      }
    